import React from 'react';
const Span = React.forwardRef((props, ref) => {
    return (
        <span {...props} ref={ref} >{props.children}</span>
    )
})
export default Span;